import React, { Component } from "react";
import Switch from "react-switch";
import PropTypes from "prop-types";

class CSLToggle extends Component {

    static defaultProps = {
        width: 40,
        height: 20,
    }

    static propTypes = {
        /** */
        width: PropTypes.number,
        /** */
        height: PropTypes.number,
        /** */
        checked: PropTypes.bool,
        /** callback: on onClick */
        onClick: PropTypes.func,
    };

    constructor(props) {
        super(props);
        // this.handleChange = this.handleChange.bind(this);
        this.state = {checked: false}
    }

    componentDidMount(){
        this.setState( { checked: this.props.checked });
    }

    componentDidUpdate(prevProps){
        if(this.props !== prevProps)
            this.setState( { checked: this.props.checked });
    }

    handleChange = (checked) => {
        this.props.onClick(checked, this.props.id)
        this.setState({ checked });
    }

    render() {
        console.log("props in Switch:", this.props);
        return (
            <Switch
                onChange={ this.handleChange }
                checked={ this.state.checked }
                onHandleColor='#11ABA6'
                offHandleColor='#CD5251'
                onColor='#F4F9FF'
                offColor='#F4F9FF'
                uncheckedIcon={false}
                checkedIcon={false}
                width={this.props.width}
                height={this.props.height}
                activeBoxShadow={null}
            />
        );
    }
}

export default CSLToggle;